//utilities and apis for email related functions
import { ENDPOINTS } from "../../redux/apiConfig";
import axiosRequest from "../../redux/slices/universal/axiosService";

export const sendEmail = async (payload,actions) => {
  // console.warn("enable sendmail in api");
  // return;
  const response = await axiosRequest({
    method: "POST",
    url: ENDPOINTS.WF_EMAILS.SEND,
    data: {
      payload,
      ...(actions?.length && { actions }),
    },
  });
  return response;
};

export const getEmailTemplate = async ({ name }) => {
  const response = await axiosRequest({
    method: "GET",
    url: ENDPOINTS.MASTER_TEMPLATES.GET_BY_UIID,
    params: {
      coll: "Template",
      ret: "name body subject",
      fil: JSON.stringify({
        name: {
          type: "NONE",
          value: name,
        },
      }),
    },
  });
  return response?.data?.data || "";
};

export const mapTemplate = (template, data) => {
  if (typeof template !== "string")
    throw new TypeError("template must be a string");
  if (!data || typeof data !== "object")
    throw new TypeError("data must be an object");

  return template.replace(/{{\s*([^{}\s]+)\s*}}/g, (_, key) => {
    const value = data[key];
    return value !== undefined && value !== null ? value : "";
  });
};
